import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import se_sv_public from './locales/sv-se/public-website.json';
import se_sv_xpektor from './locales/sv-se/xpektor.json';
import se_sv_faq from './locales/sv-se/faq.json';

i18n.use(initReactI18next).init({
  ns: ['public-website', 'app', 'faq'],
  defaultNS: 'public-website',
  fallbackNS: 'public-website',
  resources: {
    'sv-SE': { ...se_sv_public, ...se_sv_xpektor, ...se_sv_faq },
  },
  lng: 'sv-SE',
  fallbackLng: 'sv-SE',
  debug: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
